<template>
  <div>
    <!-- 具体文件的权限 -->
    <el-dialog v-dialogDrag :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="handleClose" width="1200px" top="80px" :title="dTitle">
      <div class="dialog_Body">
        <div>
          <el-radio-group v-model="userType" size="small" @change="userTypeChange">
            <el-radio-button v-for="permissionType in permissionTypeList" :key="permissionType.id"
              :label="permissionType.id">
              {{ permissionType.name }}
            </el-radio-button>
          </el-radio-group>
          <template>
            <el-button v-if="userType==3" icon="el-icon-plus" size="small" style="float:right" @click="addRole">
              新增角色
            </el-button>
            <el-button v-else-if="userType==1" icon="el-icon-plus" size="small" style="float:right" @click="addPeople">
              新增人员
            </el-button>
            <el-button v-else icon="el-icon-plus" size="small" style="float:right" @click="addMajor">
              新增专业
            </el-button>
          </template>
        </div>
        <div style="margin: 14px 0">
          <span v-if="userType===2" class="docment_title">对专业设置权限，设置的为该专业下所有角色对当前文件夹的权限</span>
          <span v-else-if="userType===3" class="docment_title">对角色设置权限，设置的为该角色下所有成员对当前文件夹的权限</span>
          <span v-else class="docment_title">对成员设置权限，设置的为该成员对当前文件夹的权限</span>
        </div>
        <div class="dialog_table">
          <el-table :key="userType" v-loading="loadShow" class="parmiss" :data="dataList" :row-style="rowStyle"
            :cell-style="cellStyle" :header-cell-style="headerStyle" height="100%" element-loading-text="获取数据中">
            <template slot="empty">
              <img :src="zanwu" alt="" />
              <p style="font-size:16px;color:#000;">
                暂无数据
              </p>
            </template>
            <template>
              <el-table-column v-if="userType==2" prop="name" label="专业" align="center">
              </el-table-column>
              <el-table-column v-else-if="userType==3" prop="name" label="角色" align="center" width="120px"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column v-else prop="name" label="人员" align="center">
              </el-table-column>
            </template>
            <el-table-column prop="isRead" label="可见" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.isRead === 1" class="el-icon-check"></i>
                <i v-if="scope.row.isRead === 2" class="el-icon-check"></i>
                <i v-if="scope.row.isRead === 0" class="el-icon-close"></i>
              </template>
            </el-table-column>
            <el-table-column prop="isRead" label="可下载" align="center">
              <template slot-scope="scope" align="center">
                <i v-if="scope.row.isRead === 2" class="el-icon-check" @click="changeAuth(scope,1)"></i>
                <i v-if="scope.row.isRead === 1" class="el-icon-close" @click="changeAuth(scope,2)"></i>
                <i v-if="scope.row.isRead === 0" class="el-icon-close" @click="changeAuth(scope,2)"></i>
              </template>
            </el-table-column>
            <el-table-column v-if="isFileNew" key="fileNew" prop="fileNew" label="上传" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.fileNew === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column prop="folderNew" label="新建文件夹" align="center" min-width="100px">
              <template slot-scope="scope">
                <i v-if="scope.row.folderNew === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>

            <el-table-column prop="fileDel" label="删除" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.fileDel === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column v-if="isSubmitShow" key="isSubmit" prop="isSubmit" label="提资准备" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.isSubmit === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column v-if="isSubmitShow" key="isPlaceFile" prop="isPlaceFile" label="归档" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.isPlaceFile === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column v-if="isSubmitShow" key="isPrint1" prop="isPrint" label="打印非正式图纸" width="120px"
              align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.isPrint === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column v-if="isPrintShow" key="isPrint2" prop="isPrint" label="成品打印" width="120px" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.isPrint === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column prop="isPriviSet" label="权限分配" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.isPriviSet === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column prop="priviAll" label="重命名" align="center">
              <template slot-scope="scope">
                <i v-if="scope.row.priviAll === 1" class="el-icon-check" @click="changeAuth(scope,0)"></i>
                <i v-else class="el-icon-close" @click="changeAuth(scope,1)"></i>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="{ row }">
                <span style="cursor: pointer;color:var(--theme-color)" @click="deleteBtn(row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose(true)">取消</el-button>
        <el-button :loading="btnLoading" type="primary" size="small" @click="confirmHandler()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择角色 -->
    <el-dialog v-dialogDrag :visible.sync="visibleRole" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="handleCloseRole" width="500px" top="80px" title="新增角色">
      <el-input v-model="filterRole" placeholder="输入关键字进行过滤" size="small" clearable>
        <template #prefix>
          <i class="el-icon-search el-input__icon" />
        </template>
      </el-input>
      <el-tree ref="roletree" :data="roleList" :props="defaultRoleProps" :filter-node-method="filterNode"
        :expand-on-click-node="false" node-key="roleId" highlight-current default-expand-all show-checkbox
        class="document-role-tree" @check="currentOrgChangeHandler">
        <template #default="{ data }">
          <div class="tree-content">
            <div style="display:flex;align-items:center;color:font-weight:400">
              <span :title="data.roleName" class="textAll">{{ data.roleName }}</span>
            </div>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseRole">取消</el-button>
        <el-button type="primary" size="small" @click="confirmHandlerRole()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择人员 -->
    <el-dialog v-dialogDrag :visible.sync="visiblePeople" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="handleClosePeople" width="500px" top="80px" class="peopleDialog" title="新增人员">
      <el-input v-model="filterPeople" placeholder="输入姓名或手机号" size="small" clearable>
        <template #prefix>
          <i class="el-icon-search el-input__icon" />
        </template>
      </el-input>
      <el-tree ref="roletree" :data="peopleList" :props="defaultProps" :filter-node-method="filterNodePeople"
        :expand-on-click-node="false" node-key="userId" highlight-current default-expand-all show-checkbox
        class="document-role-tree" @check="currentOrgChangePeople">
        <template #default="{ data }">
          <div class="tree-content">
            <div style="display:flex;align-items:center;color:font-weight:400">
              <span :title="data.roleName" class="textAll">{{ data.name }} ({{ data.username }})</span>
            </div>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClosePeople">取消</el-button>
        <el-button type="primary" size="small" :disabled="disabledPeople" @click="confirmHandlerPeople()">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="visibleMajor" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="handleCloseMajor" width="500px" top="80px" class="peopleDialog" title="新增专业">
      <el-input v-model="filterMajor" placeholder="输入专业名称" size="small" clearable>
        <template #prefix>
          <i class="el-icon-search el-input__icon" />
        </template>
      </el-input>
      <el-tree ref="roletree" :data="majorList" :props="defaultProps" :filter-node-method="filterNodeMajor"
        :expand-on-click-node="false" node-key="userId" highlight-current default-expand-all show-checkbox
        class="document-role-tree" @check="currentOrgChangePeople">
        <template #default="{ data }">
          <div class="tree-content">
            <div style="display:flex;align-items:center;color:font-weight:400">
              <span :title="data.roleName" class="textAll"> {{ data.roleName }}</span>
            </div>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseMajor">取消</el-button>
        <el-button type="primary" size="small" @click="confirmHandlerMajor()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import permission from "@/CommonDP/service/docPrivi-service";
import docService from "@/CommonDP/service/doc-service";
import { mapState } from "vuex";
import globalParams from "@/CommonDP/utils/globalParams";
import { storage } from "@/CommonDP/utils";
import newDocService from '@/xgzdService/project-service'

const ALL_PERMISSION_TYPES = [
  { id: 3, name: "角色" },
  { id: 1, name: "人员" }
];

export default {
  props: {
    message: {
      type: Object,
      required: false,
      default: () => ({
        specId: "specId",
        folderId: "folderId",
        parentId: "parentId"
      })
    }
  },
  data() {
    return {
      permissionTypeList: ALL_PERMISSION_TYPES,
      visible: true,
      loadShow: false,
      userType: 3,
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      visibleRole: false,
      visiblePeople: false,
      filterMajor: "",
      filterRole: "",
      filterPeople: "",
      roleList: [],
      defaultRoleProps: {
        label: "roleName",
        children: "childList"
      },
      peopleList: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      btnLoading: false,
      roleSelectList: [],
      peopleSelectList: [],
      rolepeopleType: "",
      visibleMajor: false,
      majorList: [],
      oldId: "",
      peopleTableList: [],
      majorTableList: [],
      roleTableList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    dTitle() {
      const suffix = this.message?.folderName || ""
      return `权限设置 ${suffix}`
    },
    prjId() {
      return storage.get("updatePrjcook");
    },
    disabledPeople() {
      return !(this.peopleSelectList.length > 0);
    },
    isFileNew() {
      return this.oldId ? this.oldId !== "1630981803194" : false;
    },
    isSubmitShow() {
      return this.oldId ? this.oldId === "1630981681702" : false;
    },
    isPrintShow() {
      return this.oldId ? this.oldId === "1630981811371" : false;
    },
    rolepeopleTitle() {
      return ["新增专业", "新增人员"][this.rolepeopleType];
    },
    dataList() {
      if (this.userType === 1) return this.peopleTableList || [];
      else if (this.userType === 2) return this.majorTableList || [];
      else if (this.userType === 3) return this.roleTableList || [];
      return [];
    }
  },
  watch: {
    filterRole(val) {
      this.$refs.roletree.filter(val);
    },
    filterPeople(val) {
      this.$refs.roletree.filter(val);
    },
    filterMajor(val) {
      this.$refs.roletree.filter(val);
    }
  },
  async created() {
    const displayTypes = globalParams.getFn("doc.permission.types", null, null);
    if (displayTypes && displayTypes.length) {
      this.permissionTypeList = ALL_PERMISSION_TYPES.filter((item) => displayTypes.includes(item.id));
    }
    if (this.permissionTypeList && this.permissionTypeList.length) {
      this.userType = this.permissionTypeList[0].id;
    }
    await this.getFolderList();
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    filterNodePeople(value, data) {
      if (!value) return true;
      return data.username.indexOf(value) !== -1 || data.name.indexOf(value) !== -1;
    },
    filterNodeMajor(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    changeAuth(scope, value) {
      console.log(scope, value);
      const obj = scope.row;
      const { property } = scope.column;
      console.log(obj[property]);
      obj[property] = value;
    },
    userTypeChange(key) {
      this.oldId = "";
      this.peopleTableList = [];
      this.majorTableList = [];
      this.roleTableList = [];
      this.userType = key;
      this.getFolderList();
    },
    async getFolderList() {
      this.loadShow = true;
      const {
        message: { folderId },
        userType
      } = this;
      const res = await permission.docPermissionQuery(folderId, userType);
      if (res.result === "0") {
        var array = res.data.list.map((item) => {
          item.$oldId = res.data.oldId;
          return item;
        });
        this.oldId = res.data.oldId;
        this.loadShow = false;
      }
      if (userType === 1) this.peopleTableList = array;
      else if (userType === 2) this.majorTableList = array;
      else if (userType === 3) this.roleTableList = array;
    },
    // 删除角色 人员
    async deleteBtn(row) {
      const { userType } = this;
      const { folderId, parentId } = this.message;
      const array = [row];
      const list = array.map((item) => {
        item.folderId = folderId;
        item.parentId = parentId;
        item.userType = userType;
        item.type = 3;
        return item;
      });
      if (userType === 3) {
        await this.$confirm(`您确定要删除${row.name}角色对本文件夹的权限吗`, { type: "warning" });
      } else if (userType === 1) {
        await this.$confirm(`您确定要删除${row.name}人员对本文件夹的权限吗`, "警告", { type: "warning" });
      } else {
        await this.$confirm(`您确定要删除${row.name}专业对本文件夹的权限吗`, "警告", { type: "warning" });
      }
      const res = await permission.updatePermissionOperation({ list: list });
      if (res.result === "0") await this.$message.success("删除成功");
      await this.getFolderList();
    },

    // 添加角色
    async addRole() {
      this.roleSelectList = [];
      this.visibleRole = true;
      const { enterpriseId, prjId } = this;
      const res = await newDocService.queryRoleListNew(prjId, enterpriseId);
      const array = res.data.map((item) => {
        item.$isOperation = 1;
        return item;
      });
      this.roleList = this.addAttr(array);
    },
    addAttr(data) {
      for (var j = 0; j < data.length; j++) {
        const a = this.dataList.some(({ userId }) => userId === data[j].roleID);
        if (a) data[j].disabled = true;
        if (data[j].childList && data[j].childList.length > 0) {
          this.addAttr(data[j].childList);
        }
      }
      return data;
    },
    handleCloseRole() {
      this.filterRole = "";
      this.visibleRole = false;
      this.getFolderList();
    },
    async confirmHandlerRole() {
      const { folderId, parentId } = this.message;
      const array = this.roleSelectList.map((item) => {
        item.fileDel = 0;
        item.fileNew = 0;
        item.folderNew = 0;
        item.isPlaceFile = 0;
        item.isPrint = 0;
        item.isPriviSet = 0;
        item.isRead = 1;
        item.priviAll = 0;
        item.isSnapshot = 0;
        item.isSubmit = 0;
        item.folderId = folderId;
        item.parentId = parentId;
        item.userType = 3;
        item.type = 1;
        item.userId = item.roleID;
        delete item.roleName;
        delete item.specId;
        delete item.templateRoleId;
        delete item.enterpriseId;
        return item;
      });
      const res = await permission.updatePermissionOperation({ list: array });
      if (res.result === "0") await this.$message.success("添加成功");
      this.handleCloseRole();
    },
    currentOrgChangeHandler(data, currentChecked) {
      this.roleSelectList = currentChecked.checkedNodes.filter((item) => {
        return item.pid;
      });
    },
    async addMajor() {
      const {
        message: { folderId },
        prjId
      } = this;
      this.majorList = [];
      this.visibleMajor = true;
      const res = await permission.specpermissionlist(prjId, folderId);
      // 过滤掉已经选择的人员
      const array = res.data.map((item) => {
        item.userId = item.specId;
        item.roleName = item.specName;
        return item;
      });
      this.majorList = array.filter((item) => {
        const idList = this.majorTableList.map((v) => v.userId);
        return !idList.includes(item.userId);
      });
    },
    // 新增人员 专业
    async addPeople() {
      this.peopleList = [];
      this.peopleSelectList = [];
      this.visiblePeople = true;
      const res = await permission.getProjectUsers(this.prjId);
      // 过滤掉已经选择的人员
      this.peopleList = res.data.filter((item) => {
        const idList = this.peopleTableList.map((v) => v.userId);
        return !idList.includes(item.userId);
      });
    },
    handleClosePeople() {
      this.filterPeople = "";
      this.visiblePeople = false;
      this.getFolderList();
    },
    handleCloseMajor() {
      this.filterMajor = "";
      this.visibleMajor = false;
      this.getFolderList();
    },
    currentOrgChangePeople(data, currentChecked) {
      this.peopleSelectList = currentChecked.checkedNodes;
    },
    async confirmHandlerMajor() {
      const { folderId, parentId } = this.message;
      const array = this.peopleSelectList.map((item) => {
        item.fileDel = 0;
        item.fileNew = 0;
        item.folderNew = 0;
        item.isPlaceFile = 0;
        item.isPrint = 0;
        item.isPriviSet = 0;
        item.isRead = 1;
        item.priviAll = 0;
        item.isSnapshot = 0;
        item.isSubmit = 0;
        item.folderId = folderId;
        item.parentId = parentId;
        item.userType = 2;
        item.type = 1;
        item.userId = item.specId;
        delete item.roleName;
        return item;
      });
      const res = await permission.updatePermissionOperation({ list: array });
      if (res.result === "0") await this.$message.success("添加成功");
      await this.handleCloseMajor();
    },
    async confirmHandlerPeople() {
      const { folderId, parentId } = this.message;
      const array = this.peopleSelectList.map((item) => {
        item.fileDel = 0;
        item.fileNew = 0;
        item.folderNew = 0;
        item.isPlaceFile = 0;
        item.isPrint = 0;
        item.isPriviSet = 0;
        item.isRead = 1;
        item.priviAll = 0;
        item.isSnapshot = 0;
        item.isSubmit = 0;
        item.folderId = folderId;
        item.parentId = parentId;
        item.userType = 1;
        item.type = 1;
        item.userId = item.userId;
        delete item.avatarFileId;
        delete item.specVoList;
        delete item.createTime;
        return item;
      });
      const res = await permission.updatePermissionOperation({ list: array });
      if (res.result === "0") await this.$message.success("添加成功");
      await this.handleClosePeople();
    },

    // 修改权限
    async confirmHandler() {
      const {
        message: { parentId, folderId },
        userType
      } = this;
      this.btnLoading = true;
      const array = this.dataList.map((item) => {
        item.folderId = folderId;
        item.parentId = parentId;
        item.type = 2;
        item.userType = userType;
        return item;
      });
      const res = await permission.updatePermissionOperation({ list: array });
      if (res.result === "0") {
        this.btnLoading = false;
        this.$message.success("编辑权限成功");
        this.handleClose();
      }
    },
    handleClose() {
      this.visible = false;
      this.$store.dispatch("XtDesignUpdateNodeList");
      this.$parent.documentShow = false;
    },

    showDialog() {
      this.visible = true;
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;height:54px;padding:0px;border-top:1px solid #EFF0F9";
    },
    rowStyle() {
      return "height:60px;padding:0px";
    },
    cellStyle() {
      return "height:60px";
    }
  }
};
</script>
<style lang="scss">
.peopleDialog {
  .el-dialog__body {
    height: 400px;
  }
}
</style>
<style  lang="scss" scoped>
.docment_title {
  color: #58667a;
  font-size: 14px;
  line-height: 18px;
}
.document-role-tree {
  margin-top: 10px;
  max-height: 310px;
  overflow: auto;
}
.el-icon-check {
  color: rgb(56, 115, 254);
  font-weight: 600;
  font-size: 18px;
}
.el-icon-close {
  color: red;
  font-weight: 600;
  font-size: 18px;
}
.dialog_Body {
  position: relative;
  height: 500px;
  .dialog_table {
    position: absolute;
    bottom: 10px;
    top: 80px;
    right: 0;
    left: 0;
    .parmiss {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
